import Thanks from "./Thanks";
export default Thanks;